// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TedH","col":"styles_col__389tX"};